/**
 * @generated SignedSource<<a1c8ecf8354152cafdf00a4e6830f58d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CloneContentModuleContentCloneMethod = "duplicate" | "reuse" | "%future added value";
export type CloneJobStatus = "error" | "in_progress" | "success" | "%future added value";
export type CloneContentModuleInput = {
  contentCloneMethod?: CloneContentModuleContentCloneMethod | null;
  contentModuleUsageId: string;
  contentUsages?: ReadonlyArray<CloneContentUsageInput> | null;
  destinationEntityId: string;
  name: string;
  releasedAt?: string | null;
};
export type CloneContentUsageInput = {
  dueAt: string;
  sourceId: string;
};
export type CloneContentModuleButtonMutation$variables = {
  contentLabelIds?: ReadonlyArray<string> | null;
  input: CloneContentModuleInput;
};
export type CloneContentModuleButtonMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly destinationContentUsage: {
        readonly collection: {
          readonly " $fragmentSpreads": FragmentRefs<"CollectionModuleList_PaginationFragment">;
        } | null;
        readonly id: string;
        readonly " $fragmentSpreads": FragmentRefs<"ContentModuleNavigationSectionFragment">;
      } | null;
      readonly destinationProduct: {
        readonly curriculum: {
          readonly id: string;
          readonly " $fragmentSpreads": FragmentRefs<"CurriculumModuleListFragment">;
        } | null;
        readonly id: string;
      } | null;
      readonly id: string;
      readonly status: CloneJobStatus;
    } | null;
  };
};
export type CloneContentModuleButtonMutation = {
  response: CloneContentModuleButtonMutation$data;
  variables: CloneContentModuleButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentLabelIds"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = [
  {
    "kind": "Variable",
    "name": "contentLabelIds",
    "variableName": "contentLabelIds"
  }
],
v5 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 6
  }
],
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "concreteType": "ValidationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "field",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerHasCompleted",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "releasedAt",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLocked",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasPrerequisites",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v17 = {
  "alias": "createCurriculumModuleItemContentUsageButtonChildren",
  "args": null,
  "concreteType": "ContentUsageNodeConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": (v9/*: any*/),
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCurriculumModule",
  "storageKey": null
},
v20 = [
  (v3/*: any*/)
],
v21 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ContentUsageNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ContentUsage",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": (v20/*: any*/),
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v22 = {
  "alias": "allChildren",
  "args": null,
  "concreteType": "ContentUsageNodeConnection",
  "kind": "LinkedField",
  "name": "children",
  "plural": false,
  "selections": (v21/*: any*/),
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v15/*: any*/),
    (v3/*: any*/)
  ],
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v27 = [
  (v26/*: any*/)
],
v28 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "Organization",
  "abstractKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v30 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "nonNullProductId",
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    (v26/*: any*/),
    (v29/*: any*/)
  ],
  "type": "Product",
  "abstractKey": null
},
v31 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v26/*: any*/),
  (v29/*: any*/)
],
v32 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "Event",
  "abstractKey": null
},
v33 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v26/*: any*/),
  (v29/*: any*/)
],
v34 = {
  "kind": "InlineFragment",
  "selections": (v33/*: any*/),
  "type": "Comment",
  "abstractKey": null
},
v35 = {
  "kind": "InlineFragment",
  "selections": (v33/*: any*/),
  "type": "Feed",
  "abstractKey": null
},
v36 = {
  "kind": "InlineFragment",
  "selections": (v33/*: any*/),
  "type": "Post",
  "abstractKey": null
},
v37 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": "nullableProductIdString",
      "args": null,
      "kind": "ScalarField",
      "name": "productId",
      "storageKey": null
    },
    (v26/*: any*/),
    (v29/*: any*/)
  ],
  "type": "ContentUsage",
  "abstractKey": null
},
v38 = {
  "kind": "InlineFragment",
  "selections": (v33/*: any*/),
  "type": "ChatChannel",
  "abstractKey": null
},
v39 = {
  "kind": "InlineFragment",
  "selections": (v33/*: any*/),
  "type": "Dashboard",
  "abstractKey": null
},
v40 = {
  "kind": "InlineFragment",
  "selections": (v31/*: any*/),
  "type": "AssignmentSubmission",
  "abstractKey": null
},
v41 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "PathwayGroup",
  "abstractKey": null
},
v42 = {
  "kind": "InlineFragment",
  "selections": (v27/*: any*/),
  "type": "BrainSearch",
  "abstractKey": null
},
v43 = {
  "kind": "InlineFragment",
  "selections": [
    (v25/*: any*/),
    (v28/*: any*/),
    (v30/*: any*/),
    (v32/*: any*/),
    (v34/*: any*/),
    (v35/*: any*/),
    (v36/*: any*/),
    (v37/*: any*/),
    (v38/*: any*/),
    (v39/*: any*/),
    (v40/*: any*/),
    (v41/*: any*/),
    (v42/*: any*/)
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v44 = {
  "alias": null,
  "args": null,
  "concreteType": "OccurrenceNodeConnection",
  "kind": "LinkedField",
  "name": "occurrences",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "OccurrenceNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Occurrence",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            (v15/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "coverPhoto",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "isComplete",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "datetimeRange",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Product",
              "kind": "LinkedField",
              "name": "product",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "cover",
                  "storageKey": null
                },
                (v15/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Event",
              "kind": "LinkedField",
              "name": "event",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Product",
                  "kind": "LinkedField",
                  "name": "product",
                  "plural": false,
                  "selections": [
                    (v14/*: any*/),
                    (v3/*: any*/)
                  ],
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "MemberGroupNodeConnection",
                  "kind": "LinkedField",
                  "name": "memberGroups",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "MemberGroupNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "MemberGroup",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v23/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "parentMemberGroupId",
                              "storageKey": null
                            },
                            (v15/*: any*/),
                            (v24/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "color",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "role",
                              "storageKey": null
                            },
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "isSystem",
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    },
                    (v8/*: any*/)
                  ],
                  "storageKey": null
                },
                (v43/*: any*/)
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "OccurrenceRSVPNodeConnection",
              "kind": "LinkedField",
              "name": "rsvps",
              "plural": false,
              "selections": (v9/*: any*/),
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "UserNodeConnection",
              "kind": "LinkedField",
              "name": "attendees",
              "plural": false,
              "selections": (v9/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entity",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "creationDatetime",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "coverVideo",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailUrl",
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "showCoverPlayIcon",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isCollectionModule",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsageNodeConnection",
  "kind": "LinkedField",
  "name": "dependents",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsage",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v3/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Content",
              "kind": "LinkedField",
              "name": "content",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v3/*: any*/),
                (v14/*: any*/),
                (v18/*: any*/),
                (v15/*: any*/),
                (v48/*: any*/),
                (v49/*: any*/),
                (v50/*: any*/),
                (v51/*: any*/),
                (v16/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "ContentUsageNodeConnection",
                  "kind": "LinkedField",
                  "name": "children",
                  "plural": false,
                  "selections": [
                    (v8/*: any*/),
                    {
                      "alias": null,
                      "args": null,
                      "concreteType": "ContentUsageNodeEdge",
                      "kind": "LinkedField",
                      "name": "edges",
                      "plural": true,
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "concreteType": "ContentUsage",
                          "kind": "LinkedField",
                          "name": "node",
                          "plural": false,
                          "selections": [
                            (v3/*: any*/),
                            (v10/*: any*/),
                            {
                              "alias": null,
                              "args": null,
                              "concreteType": "Content",
                              "kind": "LinkedField",
                              "name": "content",
                              "plural": false,
                              "selections": [
                                (v14/*: any*/),
                                {
                                  "alias": null,
                                  "args": null,
                                  "kind": "ScalarField",
                                  "name": "contentLabelId",
                                  "storageKey": null
                                },
                                (v3/*: any*/)
                              ],
                              "storageKey": null
                            }
                          ],
                          "storageKey": null
                        }
                      ],
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            (v11/*: any*/),
            (v10/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "dueAt",
              "storageKey": null
            },
            (v45/*: any*/),
            (v24/*: any*/),
            {
              "alias": null,
              "args": null,
              "concreteType": "Content",
              "kind": "LinkedField",
              "name": "module",
              "plural": false,
              "selections": [
                (v19/*: any*/),
                (v52/*: any*/),
                (v15/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            },
            (v12/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "passPercentage",
              "storageKey": null
            },
            (v47/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemTaskKind",
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Content",
  "kind": "LinkedField",
  "name": "module",
  "plural": false,
  "selections": [
    (v19/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentUsageNodeConnection",
      "kind": "LinkedField",
      "name": "children",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ContentUsageNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ContentUsage",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                (v3/*: any*/),
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "Content",
                  "kind": "LinkedField",
                  "name": "content",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/),
                    (v14/*: any*/),
                    (v15/*: any*/),
                    (v54/*: any*/),
                    (v18/*: any*/),
                    (v48/*: any*/),
                    (v49/*: any*/),
                    (v50/*: any*/),
                    (v51/*: any*/)
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v52/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductApp",
  "kind": "LinkedField",
  "name": "productApp",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "customAppTitle",
      "storageKey": null
    },
    (v3/*: any*/),
    (v23/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v58 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isDefaultCollectionModule",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "CloneContentModuleButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v2/*: any*/),
        "concreteType": "CloneContentModuleResponse",
        "kind": "LinkedField",
        "name": "cloneContentModule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CloneJob",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "destinationProduct",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Curriculum",
                    "kind": "LinkedField",
                    "name": "curriculum",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "args": (v4/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "CurriculumModuleListFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsage",
                "kind": "LinkedField",
                "name": "destinationContentUsage",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ContentModuleNavigationSectionFragment"
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Collection",
                    "kind": "LinkedField",
                    "name": "collection",
                    "plural": false,
                    "selections": [
                      {
                        "args": (v5/*: any*/),
                        "kind": "FragmentSpread",
                        "name": "CollectionModuleList_PaginationFragment"
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "CloneContentModuleButtonMutation",
    "selections": [
      {
        "alias": "response",
        "args": (v2/*: any*/),
        "concreteType": "CloneContentModuleResponse",
        "kind": "LinkedField",
        "name": "cloneContentModule",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "CloneJob",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Product",
                "kind": "LinkedField",
                "name": "destinationProduct",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Curriculum",
                    "kind": "LinkedField",
                    "name": "curriculum",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeConnection",
                        "kind": "LinkedField",
                        "name": "modules",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "prerequisites",
                                    "plural": false,
                                    "selections": (v9/*: any*/),
                                    "storageKey": null
                                  },
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/),
                                      (v16/*: any*/),
                                      {
                                        "alias": null,
                                        "args": (v4/*: any*/),
                                        "concreteType": "ContentUsageNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": false,
                                        "selections": [
                                          (v8/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentUsageNodeEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "concreteType": "ContentUsage",
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                  (v3/*: any*/),
                                                  (v12/*: any*/),
                                                  (v13/*: any*/),
                                                  {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "Content",
                                                    "kind": "LinkedField",
                                                    "name": "content",
                                                    "plural": false,
                                                    "selections": [
                                                      {
                                                        "alias": null,
                                                        "args": null,
                                                        "kind": "ScalarField",
                                                        "name": "timeEstimateMinutes",
                                                        "storageKey": null
                                                      },
                                                      (v3/*: any*/)
                                                    ],
                                                    "storageKey": null
                                                  }
                                                ],
                                                "storageKey": null
                                              }
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentCompletionNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "viewerChildContentCompletions",
                                        "plural": false,
                                        "selections": (v9/*: any*/),
                                        "storageKey": null
                                      },
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v44/*: any*/),
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v53/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  (v43/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentUsage",
                "kind": "LinkedField",
                "name": "destinationContentUsage",
                "plural": false,
                "selections": [
                  (v3/*: any*/),
                  (v11/*: any*/),
                  (v13/*: any*/),
                  (v12/*: any*/),
                  (v58/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "content",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      (v15/*: any*/),
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentUsageNodeConnection",
                        "kind": "LinkedField",
                        "name": "children",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v10/*: any*/),
                                  (v45/*: any*/),
                                  (v12/*: any*/),
                                  (v13/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "confirmationModalContent",
                                    "plural": false,
                                    "selections": (v20/*: any*/),
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v15/*: any*/),
                                      (v14/*: any*/),
                                      (v18/*: any*/),
                                      (v54/*: any*/),
                                      (v51/*: any*/),
                                      (v49/*: any*/),
                                      (v50/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Product",
                                    "kind": "LinkedField",
                                    "name": "product",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "SlackProductConnection",
                                        "kind": "LinkedField",
                                        "name": "slack",
                                        "plural": false,
                                        "selections": [
                                          (v3/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "inviteURL",
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      },
                                      (v3/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v47/*: any*/),
                                  (v43/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v17/*: any*/),
                      (v14/*: any*/),
                      (v18/*: any*/),
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v44/*: any*/),
                  (v45/*: any*/),
                  (v46/*: any*/),
                  (v47/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "ordering",
                    "storageKey": null
                  },
                  (v53/*: any*/),
                  (v55/*: any*/),
                  (v56/*: any*/),
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Collection",
                    "kind": "LinkedField",
                    "name": "collection",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "concreteType": "ContentUsageNodeConnection",
                        "kind": "LinkedField",
                        "name": "modules",
                        "plural": false,
                        "selections": [
                          (v8/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentUsageNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "cursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsage",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v58/*: any*/),
                                  (v45/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Content",
                                    "kind": "LinkedField",
                                    "name": "content",
                                    "plural": false,
                                    "selections": [
                                      (v3/*: any*/),
                                      (v14/*: any*/),
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsageNodeConnection",
                                        "kind": "LinkedField",
                                        "name": "children",
                                        "plural": false,
                                        "selections": (v21/*: any*/),
                                        "storageKey": null
                                      },
                                      (v15/*: any*/),
                                      (v17/*: any*/),
                                      (v18/*: any*/),
                                      (v19/*: any*/),
                                      (v22/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v12/*: any*/),
                                  (v53/*: any*/),
                                  (v55/*: any*/),
                                  (v56/*: any*/),
                                  (v57/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "OccurrenceNodeConnection",
                                    "kind": "LinkedField",
                                    "name": "occurrences",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "OccurrenceNodeEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Occurrence",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": (v20/*: any*/),
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v25/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v28/*: any*/),
                                      (v30/*: any*/),
                                      (v32/*: any*/),
                                      (v34/*: any*/),
                                      (v35/*: any*/),
                                      (v36/*: any*/),
                                      (v37/*: any*/),
                                      (v38/*: any*/),
                                      (v39/*: any*/),
                                      (v40/*: any*/),
                                      (v41/*: any*/),
                                      (v42/*: any*/)
                                    ],
                                    "type": "Node",
                                    "abstractKey": "__isNode"
                                  }
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "PageInfoObjectType",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "endCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "startCursor",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasNextPage",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "hasPreviousPage",
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          {
                            "kind": "ClientExtension",
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "__id",
                                "storageKey": null
                              }
                            ]
                          }
                        ],
                        "storageKey": "modules(first:6)"
                      },
                      {
                        "alias": null,
                        "args": (v5/*: any*/),
                        "filters": null,
                        "handle": "connection",
                        "key": "CollectionModuleList__modules",
                        "kind": "LinkedHandle",
                        "name": "modules"
                      },
                      (v3/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v43/*: any*/)
                ],
                "storageKey": null
              },
              (v6/*: any*/)
            ],
            "storageKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0b23212a920b7c7ffc827350dd2f2f01",
    "id": null,
    "metadata": {},
    "name": "CloneContentModuleButtonMutation",
    "operationKind": "mutation",
    "text": "mutation CloneContentModuleButtonMutation(\n  $input: CloneContentModuleInput!\n  $contentLabelIds: [ID!]\n) {\n  response: cloneContentModule(input: $input) {\n    node {\n      id\n      destinationProduct {\n        id\n        curriculum {\n          id\n          ...CurriculumModuleListFragment_pt7oe\n        }\n      }\n      destinationContentUsage {\n        id\n        ...ContentModuleNavigationSectionFragment\n        collection {\n          ...CollectionModuleList_PaginationFragment_4ktKph\n          id\n        }\n      }\n      status\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n\nfragment CollectionModuleList_PaginationFragment_4ktKph on Collection {\n  modules(first: 6) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        isDefaultCollectionModule\n        ...ContentModuleGridItemFragment\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n  id\n}\n\nfragment ContentModuleAdminDropdownFragment on ContentUsage {\n  id\n  entity\n  ...CreateContentModuleItemButtonFragment\n  ...UpdateContentModuleButtonFragment\n  ...DeleteContentUsageButtonFragment\n  ...ContentUsageAssociateEventsButtonFragment\n}\n\nfragment ContentModuleEventsListItem_OccurrenceFragment on Occurrence {\n  id\n  name\n  coverPhoto\n  isComplete\n  datetimeRange\n  product {\n    cover\n    name\n    id\n  }\n  event {\n    id\n    ...MemberGroupEventTagListFragment\n    ...usePermissionsFragment\n    memberGroups {\n      totalCount\n    }\n  }\n  rsvps {\n    totalCount\n  }\n  attendees {\n    totalCount\n  }\n}\n\nfragment ContentModuleEvents_ContentUsageFragment on ContentUsage {\n  occurrences {\n    totalCount\n    edges {\n      node {\n        id\n        ...ContentModuleEventsListItem_OccurrenceFragment\n      }\n    }\n  }\n}\n\nfragment ContentModuleGridItemFragment on ContentUsage {\n  id\n  entity\n  isDefaultCollectionModule\n  content {\n    id\n    type\n    children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n  }\n  ...ContentModuleGridItemToolbarFragment\n}\n\nfragment ContentModuleGridItemToolbarFragment on ContentUsage {\n  id\n  entity\n  isDefaultCollectionModule\n  content {\n    name\n    type\n    id\n  }\n  ...CreateContentModuleItemButtonFragment\n  ...ContentModuleAdminDropdownFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentModuleListFragment_pt7oe on ContentUsageNodeConnection {\n  edges {\n    node {\n      id\n      prerequisites {\n        totalCount\n      }\n      viewerHasCompleted\n      releasedAt\n      ...ContentModuleListItemFragment_pt7oe\n    }\n  }\n}\n\nfragment ContentModuleListItemFragment_pt7oe on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  isLocked\n  hasPrerequisites\n  content {\n    id\n    type\n    name\n    description\n    children(contentLabelIds: $contentLabelIds) {\n      totalCount\n      edges {\n        node {\n          id\n          isLocked\n          hasPrerequisites\n          content {\n            timeEstimateMinutes\n            id\n          }\n        }\n      }\n    }\n    viewerChildContentCompletions {\n      totalCount\n    }\n  }\n  occurrences {\n    totalCount\n  }\n  ...CreateContentModuleItemButtonFragment\n  ...ContentModuleReleaseCountdownFragment\n  ...ContentModuleReleaseDateFragment\n  ...ContentModuleAdminDropdownFragment\n  ...usePermissionsFragment\n  ...ContentModuleEvents_ContentUsageFragment\n  ...ContentUsageLockIconFragment\n}\n\nfragment ContentModuleNavigationSectionDividerFragment on ContentUsage {\n  id\n  entity\n  entityId\n  ordering\n  ...usePermissionsFragment\n}\n\nfragment ContentModuleNavigationSectionFragment on ContentUsage {\n  id\n  releasedAt\n  hasPrerequisites\n  isLocked\n  isDefaultCollectionModule\n  content {\n    id\n    name\n    isCurriculumModule\n    children {\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          ...ContentUsageNavigationItemFragment\n        }\n      }\n    }\n  }\n  occurrences {\n    totalCount\n  }\n  ...CreateContentModuleItemButtonFragment\n  ...ContentModuleNavigationSectionDividerFragment\n  ...ContentModuleEvents_ContentUsageFragment\n  ...ContentModuleAdminDropdownFragment\n  ...ContentUsageLockIconFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentModuleReleaseCountdownFragment on ContentUsage {\n  releasedAt\n}\n\nfragment ContentModuleReleaseDateFragment on ContentUsage {\n  id\n  releasedAt\n}\n\nfragment ContentThumbnailWithDetails_ContentFragment on Content {\n  id\n  type\n  label\n  name\n  creationDatetime\n  ...ContentThumbnail_ContentFragment\n}\n\nfragment ContentThumbnailWithDetails_ContentUsageFragment on ContentUsage {\n  id\n  dueAt\n  entity\n  product {\n    name\n    id\n  }\n  module {\n    isCurriculumModule\n    isCollectionModule\n    name\n    id\n  }\n}\n\nfragment ContentThumbnail_ContentFragment on Content {\n  id\n  type\n  coverVideo\n  thumbnailUrl\n  showCoverPlayIcon\n}\n\nfragment ContentUsageAssociateEventsButtonFragment on ContentUsage {\n  id\n  productId\n  organizationId\n  occurrences {\n    edges {\n      node {\n        id\n      }\n    }\n  }\n}\n\nfragment ContentUsageLockIconFragment on ContentUsage {\n  id\n  entity\n  content {\n    name\n    id\n  }\n  ...UpdateContentModuleButtonFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentUsageNavigationItemFragment on ContentUsage {\n  id\n  entity\n  viewerHasCompleted\n  isLocked\n  hasPrerequisites\n  confirmationModalContent {\n    id\n  }\n  content {\n    id\n    name\n    type\n    label\n    systemTaskKind\n    showCoverPlayIcon\n    coverVideo\n    thumbnailUrl\n  }\n  product {\n    slack {\n      id\n      inviteURL\n    }\n    id\n  }\n  ...ContentUsageLockIconFragment\n  ...usePermissionsFragment\n}\n\nfragment ContentUsagePrerequisiteItemFragment on ContentUsage {\n  id\n  releasedAt\n  viewerHasCompleted\n  ...ContentThumbnailWithDetails_ContentUsageFragment\n  isLocked\n  passPercentage\n  content {\n    id\n    isCurriculumModule\n    ...ContentThumbnailWithDetails_ContentFragment\n    name\n    type\n    description\n    children {\n      totalCount\n      edges {\n        node {\n          id\n          viewerHasCompleted\n          content {\n            type\n            contentLabelId\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ContentUsageUtils_UseParentEntityContentUsageFragment on ContentUsage {\n  id\n  entity\n  module {\n    isCurriculumModule\n    isCollectionModule\n    id\n  }\n  productApp {\n    kind\n    id\n  }\n}\n\nfragment ContentUsageUtils_useNavigateToNextContentUsageFragment on ContentUsage {\n  id\n  module {\n    children {\n      edges {\n        node {\n          id\n          content {\n            id\n            type\n            name\n            systemTaskKind\n            ...ContentThumbnailWithDetails_ContentFragment\n          }\n        }\n      }\n    }\n    id\n  }\n}\n\nfragment CreateCollectionModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  content {\n    id\n  }\n  productId\n}\n\nfragment CreateContentModuleItemButtonFragment on ContentUsage {\n  id\n  entity\n  ...CreateCollectionModuleItemContentUsageButtonFragment\n  ...CreateCurriculumModuleItemContentUsageButtonFragment\n}\n\nfragment CreateCurriculumModuleItemContentUsageButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    id\n    createCurriculumModuleItemContentUsageButtonChildren: children {\n      totalCount\n    }\n  }\n  productId\n}\n\nfragment CurriculumModuleListFragment_pt7oe on Curriculum {\n  id\n  modules {\n    ...ContentModuleListFragment_pt7oe\n  }\n}\n\nfragment DeleteContentUsageButtonFragment on ContentUsage {\n  id\n  isLocked\n  entity\n  entityId\n  productId\n  dependents {\n    edges {\n      node {\n        id\n        content {\n          isCurriculumModule\n          id\n        }\n        ...ContentUsagePrerequisiteItemFragment\n        ...UpdateContentModuleButtonFragment\n      }\n    }\n  }\n  module {\n    isCurriculumModule\n    id\n  }\n  content {\n    type\n    label\n    isCurriculumModule\n    allChildren: children {\n      edges {\n        node {\n          id\n        }\n      }\n    }\n    id\n  }\n  productApp {\n    customAppTitle\n    id\n  }\n  ...ContentUsageUtils_useNavigateToNextContentUsageFragment\n  ...ContentUsageUtils_UseParentEntityContentUsageFragment\n}\n\nfragment MemberGroupEventTagListFragment on Event {\n  id\n  product {\n    type\n    id\n  }\n  memberGroups {\n    edges {\n      node {\n        id\n        kind\n        parentMemberGroupId\n        name\n        product {\n          name\n          id\n        }\n        ...MemberGroupTagFragment\n      }\n    }\n  }\n}\n\nfragment MemberGroupTagFragment on MemberGroup {\n  id\n  name\n  kind\n  color\n  role\n  isSystem\n  product {\n    id\n    name\n  }\n}\n\nfragment UpdateContentModuleButtonFragment on ContentUsage {\n  id\n  entity\n  entityId\n  content {\n    type\n    label\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "25367802f3b40a3bbf9afc0567387725";

export default node;
